import { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import Header from "./Header";
import BottomBar from "./BottomBar";
import WinnersMarquee from "./WinnersMarquee";
import LowBalanceNudge from "./LowBalanceNudge";
import InstallPrompt from "./InstallPrompt";
import { useLang } from "../context/LangContext";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export default function Layout() {
  const { t } = useLang();
  const { user } = useAuth();
  const [maint, setMaint] = useState({ maintenance: false, message: "" });

  useEffect(() => {
    const check = () => api.get("/status").then(({ data }) => setMaint(data)).catch(() => {});
    check();
    const id = setInterval(check, 20000);
    return () => clearInterval(id);
  }, []);

  const blocked = maint.maintenance && user?.role !== "admin";

  return (
    <div className="min-h-screen grid-noise">
      <Header />
      <WinnersMarquee />
      <InstallPrompt />
      {!blocked && <LowBalanceNudge />}
      <main className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 pb-28 md:pb-10">
        {blocked ? (
          <div className="min-h-[60vh] grid place-items-center text-center" data-testid="maintenance-notice">
            <div className="mw-card max-w-md p-8 space-y-4">
              <div className="mx-auto grid place-items-center h-16 w-16 rounded-2xl bg-amber-500/15 ring-1 ring-amber-500/40 text-amber-300">
                <Wrench size={30} />
              </div>
              <h1 className="font-display text-2xl font-extrabold gold-text">{t("maintenanceTitle")}</h1>
              <p className="text-sm text-slate-300">{maint.message || t("maintenanceDefault")}</p>
            </div>
          </div>
        ) : (
          <Outlet />
        )}
      </main>
      <footer className="relative z-10 border-t border-amber-500/15 py-5 text-center text-xs text-slate-500 mb-16 md:mb-0">
        {t("disclaimer")}
        <Link to="/app/rules" data-testid="footer-rules-link" className="text-amber-300/80 hover:text-amber-200 underline">{t("rulesTerms")}</Link>
      </footer>
      <BottomBar />
    </div>
  );
}
